import useInfiniteFetch from '@hooks/useInfiniteFetch';
import { getCMSHost } from '@utils/api-helper/host';
import { unstable_serialize } from 'swr/infinite';

const defaultCMSHost = getCMSHost();

const usePlaylists = (
  goalUID,
  options = { fallbackData: undefined, revalidateOnMount: false }
) => {
  const key = `${defaultCMSHost}api/youtube-playlist-courses/getplaylists/${goalUID}?limit=16&offset=0`;

  const { data: playlists, ...rest } = useInfiniteFetch(
    key,
    { applyOffsetsAutomatically: false },
    {
      fallbackData: options.fallbackData ? [options.fallbackData] : undefined,
      revalidateOnMount: options.revalidateOnMount,
      revalidateFirstPage: false
    }
  );

  return {
    playlists,
    ...rest,
    key: unstable_serialize(() => key)
  };
};

export default usePlaylists;
